import OpticksSvgElement from "@/components/ui/OpticksSvgElement/OpticksSvgElement";
import type { OpticksSvgElementProps } from "@/components/ui/OpticksSvgElement/OpticksSvgElement.types";

// Collection: Tabler Icons
const BrandOAuthIcon = ({
  className,
  size = 16,
  "aria-label": ariaLabel,
}: OpticksSvgElementProps) => (
  <OpticksSvgElement
    className={`icon-brand-oauth${className ? ` ${className}` : ""}`}
    size={size}
    aria-label={ariaLabel}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path
      d="M1.33334 7.99999C1.33334 9.7681 2.03571 11.4638 3.28596 12.714C4.5362 13.9643 6.23189 14.6667 8 14.6667C9.76811 14.6667 11.4638 13.9643 12.714 12.714C13.9643 11.4638 14.6667 9.7681 14.6667 7.99999C14.6667 6.23188 13.9643 4.53619 12.714 3.28595C11.4638 2.03571 9.76811 1.33333 8 1.33333C6.23189 1.33333 4.5362 2.03571 3.28596 3.28595C2.03571 4.53619 1.33334 6.23188 1.33334 7.99999Z"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.37067 4C8.804 4 9.194 4.24867 9.376 4.63133L11.2687 9.86333C11.3174 9.99978 11.3385 10.1445 11.331 10.2892C11.3235 10.4339 11.2874 10.5756 11.2248 10.7063C11.1622 10.8369 11.0743 10.9539 10.9663 11.0504C10.8583 11.1469 10.7322 11.2211 10.5953 11.2687C10.336 11.3609 10.0518 11.3539 9.79728 11.2492C9.54278 11.1445 9.33599 10.9493 9.21667 10.7013L8.91 10H7.09L6.82467 10.6033C6.73 10.8619 6.5429 11.0762 6.29948 11.2048C6.05607 11.3335 5.77362 11.3674 5.50667 11.3L5.40467 11.2687C5.14567 11.1785 4.92979 10.9947 4.79951 10.7533C4.66923 10.512 4.63397 10.2307 4.70067 9.96467L6.58333 4.73C6.65525 4.53268 6.7817 4.35983 6.94799 4.23155C7.11427 4.10326 7.31356 4.02482 7.52267 4.00533L8.37067 4Z"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </OpticksSvgElement>
);

export default BrandOAuthIcon;
